import * as React from "react";
import SignInImplementation from "./SignIn";
import SignOutImplementation from "./SignOut";
import RegisterImplementation from "./Register";

const SignIn = (props: any) => <SignInImplementation {...props}/>;
const SignOut = (props: any) => <SignOutImplementation {...props}/>;
const Register = (props: any) => <RegisterImplementation {...props}/>;

export {SignIn, SignOut, Register};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/index.tsx